// extracted by mini-css-extract-plugin
export default {"loadingButton":"styles_loadingButton__HJ1IM","dark":"styles_dark__Jpu9X"};